import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';

class Inventory extends ChemComponent {
  	constructor(props) {
		super(props);
		
		this.state = {
			inventoryList: this.copyTable(inventoryList),
			searchCount: null,
			renderKey: 1,
		};
	}
	
	onSubmitSearch(event, newOrder) {
		var newInventoryList = this.copyTable(inventoryList);
		newInventoryList.query.order = newOrder;
		this.mergeState({ 
			inventoryList: newInventoryList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	render() {

		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Inventory',
			columns: exportColumns,
			entity: 'REUSE.INVENTORY_REPORT_VW',
			order: this.copyObject(this.state.inventoryList.query.order)
		});			

		return (<>
			<Container fluid>
				<Row>
				  <Col xs={12} style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Inventory</span>

					  <Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
						<Col xs={3} style={{ marginTop: 8}}>
							{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
								{exportData.map((excelFormField, index) => {
									return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={1} style={{ marginTop: 6}}>
							<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
								{exportData.map((pdfFormField, index) => {
									return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
								})}
								<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
								  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							    </OverlayTrigger>
							</form>
						</Col>
						<Col xs={6}>
						</Col>
					  </Form.Group>
				  </Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='Reuse_Inventory' table={this.state.inventoryList}
							order={this.state.inventoryList.query.order} onTableSort={(newOrder) => this.onSubmitSearch(null, newOrder)}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='140px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const inventoryList = {
	query: { entity: 'REUSE.INVENTORY_REPORT_VW', order: ['ROOM','LOC','CHEM_NAME'] },
	pageSize: 20,
	columns: [
		{ Header: 'ID', accessor: 'BOTTLE_ID', width: 70 },
		{ Header: 'CAS Number', accessor: 'CAS_NUMBER', width: 110 },
		{ Header: 'Name', accessor: 'CHEM_NAME', width: 500 },
		{ Header: 'Amount', accessor: 'AMOUNT', width: 70 },
		{ Header: 'Unit', accessor: 'UNIT_NAME', width: 50 },
		{ Header: 'Date Shelved', accessor: 'DATE_SHELVED', width: 100 },
		{ Header: 'Date on Bottle', accessor: 'DATE_ON_BOTTLE', width: 110 },
		{ Header: 'State', accessor: 'CHEM_STATE', width: 60 },
		{ Header: 'Purity', accessor: 'PURITY', width: 70 },
		{ Header: 'Room', accessor: 'ROOM', width: 125 },
		{ Header: 'Cat.', accessor: 'CATEGORY_CODE', width: 70 },
		{ Header: 'Cont. Type', accessor: 'CONT_TYPE', width: 85 },
		{ Header: 'Loc.', accessor: 'LOC', width: 60 },
		{ Header: 'Type', accessor: 'TYPE_NAME', width: 70 },
		{ Header: 'Shelf Code', accessor: 'SHELF_CODE', width: 100 },
		{ Header: 'GHS', accessor: 'GHS', width: 50 }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'BOTTLE_ID', width: 14 },
	{ Header: 'CAS Number', accessor: 'CAS_NUMBER', width: 22 },
	{ Header: 'Name', accessor: 'CHEM_NAME', width: 100 },
	{ Header: 'Amount', accessor: 'AMOUNT', width: 14 },
	{ Header: 'Unit', accessor: 'UNIT_NAME', width: 10 },
	{ Header: 'Date Shelved', accessor: 'DATE_SHELVED', width: 20 },
	{ Header: 'Date on Bottle', accessor: 'DATE_ON_BOTTLE', width: 22 },
	{ Header: 'State', accessor: 'CHEM_STATE', width: 12 },
	{ Header: 'Purity', accessor: 'PURITY', width: 14 },
	{ Header: 'Room', accessor: 'ROOM', width: 25 },
	{ Header: 'Cat.', accessor: 'CATEGORY_CODE', width: 14 },
	{ Header: 'Cont. Type', accessor: 'CONT_TYPE', width: 17 },
	{ Header: 'Loc.', accessor: 'LOC', width: 12 },
	{ Header: 'Type', accessor: 'TYPE_NAME', width: 14 },
	{ Header: 'Shelf Code', accessor: 'SHELF_CODE', width: 20 },
	{ Header: 'GHS', accessor: 'GHS', width: 10 }
];

export default withRouter(Inventory);